import axios from "axios"


class ClickForGlossary {
  // 1. describe and create/initiate our object
  //http://localhost/present/wp-json/present/v1/search?term='aster'
  // si dans une page on click sur un élémént qui a la class "clickForGlossary", alors
  //on affichera un popup avec la définition du mot
  constructor() {
    
    //ajout html de la popup
    this.containerClass = document.getElementsByClassName("main-container")
    this.container = this.containerClass[0]
    this.addPopupHTML()
    //preparation des variables
    this.popup = document.getElementById("glossary-popup")
    this.popupTexts = document.getElementById("popup-texts")
    this.closeButton = document.querySelector(".popup-close")
    this.items = document.getElementsByClassName("clickForGlossary")
    this.motAChercher = ""
    this.events()
  }

  // 2. events
  events() {
    //ajout listener si on a la class "clickForGlossary"
    if (this.items.length > 0){ 
        for (const item of this.items) {
            //item.addEventListener("click", () => this.trtPopup(item))
            this.addListener(item)
        }
    }else{
        //alert ("pas de class click")
        return
    }

    this.closeButton.addEventListener("click", () => this.closePopup())
  
  }

  // 3. methods (function, action...)

  addListener(item){
    item.addEventListener("click", () => this.trtPopup(item))
  }
  trtPopup(element){ 
    
    //on extrait le mot a rechercher
    this.motAChercher = element.innerHTML

    //on envoie la requete avec filtre sur ce mot

    //on rempli la popup
    this.getResults() 
    //on affiche la popup
    this.openPopup()
  }

  async getResults() {
    try { 
        const response = await axios.get(presentData.root_url + '/wp-json/present/v1/glossary?term=' + this.motAChercher )
        const results = response.data
        
        this.popupTexts.innerHTML = `
                ${results.map(item => `<h2 id="popup-title">${item.title}</h2>`)}
                ${results.map(item => `<div id="popup-def">${item.content}</div>`)}
        `
    } catch (e) {
      console.log(e)
    }
  }


  openPopup(){
    this.popup.classList.remove("popupNone");
    this.popup.classList.add("popupFlex");
  }

  closePopup(){
    this.popup.classList.remove("popupFlex");
    this.popup.classList.add("popupNone");
  }



  addPopupHTML() {
   
    
    this.container.insertAdjacentHTML(
        "beforeend",
        `
        <div id="glossary-popup" class="popup popupNone">
            <div id="popup-content">
              <div id="popup-close">
                <span class="popup-close">&times;</span>
              </div>  
              <div id="popup-texts">
                
              </div>
            </div>
          </div>
        
        `
    )
  }
}

export default ClickForGlossary
